/**
 * Sanitizes text by removing control characters and special Unicode characters while preserving common whitespace characters.
 * This is particularly useful for cleaning text that will be used in Excel exports or other
 * external systems that may be sensitive to control characters.
 *
 * Removes:
 * - C0 control characters (ranges \u0000-\u0008, \u000B-\u000C, \u000E-\u001F):
 *   - Null character, Bell, Backspace
 *   - Vertical Tab through Unit Separator (excluding CR)
 * - DELETE character (\u007F)
 * - C1 control characters (\u0080-\u009F)
 * - Special Unicode characters:
 *   - Byte Order Mark (BOM) (\uFEFF)
 *   - Invalid character (\uFFFE)
 *   - Replacement character (\uFFFD)
 *   - Non-breaking space (\u00A0)
 *   - Soft hyphen (\u00AD)
 *   - Zero-width characters (\u200B, \u200C, \u200D)
 *   - Bidirectional marks (\u200E, \u200F)
 *   - Bidirectional embedding controls (\u202A-\u202E)
 *   - Invisible mathematical operators (\u2060-\u2063)
 *   - Interlinear annotation markers (\uFFF9-\uFFFB)
 *   - Variation selectors (\uFE00, \uFE0F)
 *   - Tags (\uE0000-\uE007F)
 *   - Line and paragraph separators (\u2028, \u2029)
 *
 * Preserves:
 * - Tab (\u0009)
 * - Line Feed (\u000A)
 * - Carriage Return (\u000D)
 * - Regular space (\u0020)
 * - All other printable characters
 *
 * @param input - The string to be sanitized
 * @returns The sanitized string with control characters removed
 */
export const sanitizeText = (input: string): string => {
  if (!input) return '';

  return input.replace(
    // eslint-disable-next-line no-control-regex
    /[\uFE00-\uFE0F\u0000-\u0008\u000B-\u000C\u000E-\u001F\u007F-\u009F\u00A0\u00AD\u200B-\u200F\u202A-\u202E\u2028-\u2029\u2060-\u2063\uFFF9-\uFFFB\uFFFD-\uFFFE\uFEFF]/g,
    '',
  );
};
